<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
                class="mb-8 user-list-filters hidden" :collapse-action="true">
                <div class="vx-row">
                    <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                        <label class="text-sm opacity-100 text-bold">Search</label>
                        <vs-input type="search" v-model="filters['search']" class="w-full mb-4 md:mb-0" />
                    </div>
                </div>
                <div class="mt-5 vx-row">
                    <div class="w-full ml-auto vx-col">
                        <vs-button class="float-right mr-4" size="small" color="danger" type="border"
                            icon-pack="feather" v-on:click="filters = {}">CLEAR</vs-button>
                    </div>
                </div>
            </vx-card>
            <vx-card :title="'Skills'" class="" noShadow cardBorder>
                <template slot="actions" v-if="action_buttons">
                    <vs-button @click.stop="onClickAdd" icon-pack="feather"
                        icon="icon-plus" class="mr-4" color="primary" type="filled">Add New</vs-button>
                </template>
                <div id="my-skill-table" class="vx-row">
                    <div class="w-full vx-col">

                        <vs-table stripe sort class="mt-8" :data="my_skills">
                            <template slot="thead">
                                <vs-th width="30%">Name</vs-th>
                                <vs-th width="15%">Category</vs-th>
                                <vs-th width="15%">Proficiency Level</vs-th>
                                <vs-th width="10%">Status</vs-th>
                                <vs-th width="10%" v-if="action_buttons">ACTION</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                                    <vs-td :data="data[indextr].name">
                                        {{ data[indextr].name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].category.name">
                                        {{ data[indextr].category.name }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].proficiency_level">
                                        {{ data[indextr].proficiency_level || 'N/A' }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].is_active">
                                        <vs-chip transparent :color="data[indextr].is_active ? 'primary' : 'danger'">
                                            {{ data[indextr].is_active ? 'Active' : 'De-Active' }}
                                        </vs-chip>
                                    </vs-td>

                                    <vs-td v-if="action_buttons">
                                        <div class="justify-start vx-row">
                                            <vx-tooltip text="View/Update" position="left">
                                                <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3"
                                                    size="small" color="warning" type="border" icon-pack="feather"
                                                    icon="icon-edit-2"></vs-button>
                                            </vx-tooltip>
                                            <vx-tooltip text="Delete Skill" position="left">
                                                <vs-button @click.stop="onClickDeleteConfirmation(data[indextr].id)"
                                                    class="ml-3" size="small" color="danger" type="border"
                                                    icon-pack="feather" icon="icon-trash"></vs-button>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>

                                </vs-tr>
                            </template>

                        </vs-table>
                        <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                            :max-items="perPage" description-body="Rows per page" description-connector="of"
                            description-title="Records" description :description-items="descriptionItems"
                            :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                        </vs-pagination>


                    </div>
                </div>
            </vx-card>
        </div>
        <AddNewMySkillPopUp ref="addNewMySkillPopUp" />
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
import AddNewMySkillPopUp from '@/components/popups/my-skill-qualifications/AddNewMySkillPopUp.vue'

import vSelect from 'vue-select'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import { defaultPagination, perPageList } from "@/constants/config";

const SkillQualificationRepository = RepositoryFactory.get('skills');

export default {
    name: "ManageMySkiil",
    data() {
        return {
            my_skills: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList
        }
    },
    props: {
        staff_id: {
            type: String, 
            required: true
        },
        action_buttons: {
            type: Boolean,
            default: true
        }
    },
    components: {
        AddNewMySkillPopUp,
        'v-select': vSelect,
    },
    methods: {
        async refreshData() {
            await this.fetchMySkills()
        },
        async fetchMySkills() {
            await this.$vs.loading({
                container: '#my-skill-table',
                scale: 0.45
            })
            const { data } = await SkillQualificationRepository.getListOfMySkills(this.staff_id, this.page, this.filterQuery, this.perPage, this.sort)
            this.my_skills = data.data
            this.meta = data.meta
            this.$vs.loading.close('#my-skill-table > .con-vs-loading')
        },
        async onClickAdd() {
            await this.$refs.addNewMySkillPopUp.openPopup()
        },
        async onClickUpdate(id) {
            await this.$refs.addNewMySkillPopUp.openPopup(id)
        },
        filterQueryUpdate() {
            this.fetchMySkills()
        },
        handleChangePage(page) {
            this.page = page;
            this.fetchMySkills()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchMySkills()
            }
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        onClickDeleteConfirmation(id) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm`,
                text: 'Are you sure you want to delete this ?',
                accept: this.onClickDelete,
                parameters: [id]
            })
        },
        async onClickDelete(params) {
            await this.$vs.loading({
                container: '#my-skill-table',
                scale: 0.45
            })
            try {
                await SkillQualificationRepository.deleteMySkills(params[0])
                await this.refreshData()
            } catch (error) {

            } finally {
                this.$vs.loading.close('#my-skill-table > .con-vs-loading')
            }
        }
    },
    async mounted() {

    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
    watch: {
        page() {
            this.fetchMySkills()
        },
        perPage() {
            this.fetchMySkills()
        }
    }
}
</script>

<style scoped></style>